import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ComparisonPage from "@/pages/comparison/page";
import TemplatesPage from "@/pages/templates/page";
import ReviewsPage from "@/pages/reviews/page";
import SecurityPage from "@/pages/security/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-comparison",
    element: <ComparisonPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-templates",
    element: <TemplatesPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-review",
    element: <ReviewsPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-security",
    element: <SecurityPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;